var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4",attrs:{"id":"app"}},[_c('Header'),_c('LedgerNav'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }